import styled from 'styled-components';
import { palette } from '../styles';

export const AddCompanyContainer = styled.div`
  width: 100%;
  padding: 20px;
  .a-form-left {
    width: 46%;
    display: inline-block;
    align-items: center;
    margin: 10px;
    vertical-align: top;
    margin-left: 25px;
  }
  .a-form-right {
    width: 47%;
    display: inline-block;
    align-items: center;
    margin: 10px;
    vertical-align: top;
  }
  .a-input-company {
    width: 90%;
    display: block;
    margin-right: auto;
    padding: 5px;
    font-size: 1.6rem;
  }
  .a-label-company {
    width: 100%;
    display: block;
    text-align: start;
    font-size: 1.7rem;
    margin-bottom: 0px;
    margin-top: 15px;
    font-weight: 700;
  }
  .a-form-desc {
    margin-top: 15px;
    display: block;
    width: 100%;
    margin-left: 2.5%;
  }
  .asds{
    width: 90%;
    display: block;
    font-size: 1.6rem;
    resize: none;
    border: solid 1px var(--border-color-gray);
  }
  .a-form-button{
    width: 100%;
    padding: 10px;
    display: flex;
    margin-top: 15px;
    margin-bottom: 15px;
    justify-content: flex-end;
  }
  .clear{
    clear: both;
  }
  .a-main-card-show{
    padding: 10px;
    min-height: fit-content;
    background-color: var(--white-color);
    display: block;
    position: relative;
    right: 0;
    transition: 1.5s;
  }
  .a-main-card-hide{
    background-color: var(--white-color);
    right: -100%;
    position: fixed;
    width: calc(100vw - 260px);
    transition: 1.5s;
  }
  .a-button-company{
    background-color: var(--button-color);
    font-size: 1.6rem;
    color: white;
    padding: 10px;
    padding-left: 15px;
    padding-right: 15px;
    border-radius: 5px;
    margin-right: 10%;
  }
  .a-toggle-password{
    width: 100%;
    margin-left: auto;
    margin-right: auto;
    margin-top: 5px;
  }
  .a-button-random-password{
    background-color: var(--font-text-blue);
    font-size: 1.3rem;
    color: white;
    font-weight: 700;
    padding: 7px;
    padding-left: 12px;
    padding-right: 12px;
    border-radius: 5px;
    margin-left: auto;
    margin-right: auto;
    margin-top: 20px;
    margin-bottom: auto;
    display: block;
  }
  .required-field{
    font-size: 1.8rem;
    color: red;
    margin-left: 5px;
  }
  .handle-sending-link{
    font-size: 1.4rem;
    background-color:  var(--disabled-color);
    padding-left: 10px;
    padding-right: 10px;
    padding-top: 5px;
    padding-bottom: 5px;
    display: inline-block;
    margin-left: auto;
    margin-right: 30px;
    align-self: center;
    color:  var(--white-color);
    font-weight: 700;
  }
  .adt-special{
    display: flex;
    align-content: center;
    justify-content: space-between;
  }
  .no-required-field-text{
    font-size: 1.45rem;
    display: inline-block;
    padding: 2px;
    width: 50%;
    text-align: start;
    color: red;
    padding-left: 45px;
    font-weight: 700;
  }
  .required-fields{
    width: 100%;
    padding: 5px
  }
  .link-generate-label{
    font-size: 1.4rem;
    display: inline-block;
    margin-left: 15px;
  }
  .checkbox-generate-link{
    display: inline-block;
    margin-left: 10px;
    margin-right: 10px;
  }
  .input-labels-hc-container{
    display: flex;
    width: 80%;
    padding: 5px;
    margin-right: auto;
    margin-left: auto;
  }
  .a-send-link-company{
    display: block;
    margin-left: auto;
    margin-right: auto;
    font-size: 1.4rem;
    padding-left: 12px;
    padding-right: 12px;
    padding-bottom: 6px;
    padding-top: 6px;
    border-radius: 4px;
    background-color: var(--font-text-blue);
    color: var(--white-color);
    margin-bottom: 20px;
    margin-top: 20px;
  }
  .link-to-company{
    font-size: 1.6rem;
    color: var(--lapieza-color);
    width: 80%;
    display: block;
    margin-right: auto;
    margin-left: auto;
    text-align: center;
    font-weight: 700;
  }
  .link-generated-text{
    font-size: 1.6rem;
    font-weight: 400;
    text-align: center;
    color: var(--lapieza-color);
  }
  .copy-to-clipboard{
    font-size: 1.4rem;
    display: block;
    margin-top: 10px;
    margin-bottom: 10px;
    margin-right: auto;
    margin-left: auto;
    color: var(--success-text);
  }
  .input-destiny-generate-link{
    width: 70%;
    font-size: 1.3rem;
    display: block;
    padding: 3px;
  }
  .invitation-list-show{
    display: block;
    position: relative;
    right: 0;
    transition: 1.5s;
  }
  .invitation-list-hide{
    right: -100%;
    position: fixed;
    width: calc(100vw - 260px);
    transition: 1.5s;
  }
  .invitation-detail-hide{
    right: -100%;
    position: fixed;
    width: calc(100vw - 260px);
    transition: 1.5s;
  }
  .invitation-detail-show{
    display: block;
    position: relative;
    right: 0;
    transition: 1.5s;
  }
  .back-to-list-invitations{
    font-size: 1.7rem;
    font-weight: 500;
    cursor: pointer;
    text-align: start;
    display: block;
    color: var(--lapieza-color);
    margin-right: auto;
    margin-left: 30px;
    margin-top: 15px;
    margin-bottom: -10px;
    text-decoration: underline;
  }
  .company-logo-detail{
    display: block;
    width: 18%;
  }
  .company-list-detail{
    width: 95%;
    display: block;
    margin-left: auto;
    margin-right: auto;
    padding: 10px;
  }
  .company-field-detail{
    font-size: 1.6rem;
    width: 50%;
    display: inline-block;
    font-weight: 700;
  }
  .company-validation-detail{
    font-size: 1.9rem;
    font-weight: 600;
    width: 100%;
    display: block;
    color: var(--background-job-item);
  }
  .ac-info-side-jl-acc{
    width: 35%;
    padding-left: 40px;
  }
  .ac-info-side-jl-action-acc{
    width: 60%;
    padding-left: 40px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .company-aditional-data{
    margin: 0px;
    font-size: 1.7rem;
    font-weight: 600;
  }
  .company-field-detail-link{
    font-size: 1.7rem;
    color: var(--font-text-blue);
    text-decoration: underline;
    width: auto;
    margin-left: auto;
    display: block;
    margin-top: 10px;
    margin-bottom: 10px;
  }
  .companies-ap{
    background-color: var(--white-color);
    padding: 10px;
    margin-top: 0px;
    font-size: 1.7rem;
  }
  .send-link-title{
    font-size: 2rem;
    width: 80%;
    display: block;
    margin-left: auto;
    margin-right: auto;
    padding: 20px;
    text-align: center;
  }
  .link-to-register-form{
    font-size: 1.9rem;
    width: 80%;
    display: block;
    margin-left: auto;
    margin-right: auto;
    padding: 20px;
    text-align: center;
    color: var(--button-color);
    cursor: pointer;
  }
  .mainContainer {
    width: 100%;
    padding: 20px;
  }
  .navItem {
    width: 50%;
    padding: 10px;
    font-size: 1.6rem;
    font-weight: 600;
    padding: 12px 0px;
    color: ${palette.black};
    text-align: center;
    margin: 0px;
    cursor: pointer;
    height: 55px;
  }
  .navItemActive {
    width: 50%;
    padding: 10px;
    font-size: 1.6rem;
    font-weight: 600;
    padding: 12px 0px;
    text-align: center;
    margin: 0px;
    background-color: rgba(83, 115, 252, .2);
    color: #0f3f44;
    cursor: pointer;
    border-radius: 8px;
    cursor: pointer;
    height: 55px;
  }
  .generalSettingsPage {
    width: 100%;
    margin-top: 30px;
    display:  flex;
    padding: 0px;
    align-items: flex-start;
    flex-direction: row;
    justify-content: flex-start;
    flex-wrap: wrap;
  }
  .customInput {
    background-color: #fff !important;
    border: #D3DBDD solid 1px !important;
    padding: 12px 8px !important;
    font-size: 1.7rem !important;
    color: ${palette.black};
    border-radius: 8px;
    margin: 8px 0;
  }
  
  .createAccountButton {
    background-color: ${palette.white};
    color: ${palette.black};
    padding: 5px 18px;
    border-radius: 4px;
    font-size: 1.1rem;
    margin: 25px auto 25px 35%;
    @media only screen and (max-width: 700px) {
      font-size: 1.8rem;
    }
  }
  .inputBox100 {
    width: 100%;
    padding: 0px;
    margin: 0px;
  }
  .inputLabel, .customLabel {
    font-size: 1.35rem !important;
    font-weight: 400;
    margin-top: 10px;
    display: block;
  }
  .signupInput100 {
    width: 100%;
    margin: auto !important;
    background-color: #EEF2F8;
    border: none !important;
    padding: 6px 4px !important;
    font-size: 1.3rem !important;
    color: ${palette.black};
  }
  .subjectInput {
    width: 100%;
    margin: auto !important;
    background-color: #EEF2F8;
    border: none !important;
    padding: 6px 6px !important;
    font-size: 2rem !important;
    color: ${palette.black};
    border-radius: 8px;
  }
  .backdrop {
    z-index: 1;
    color: #fff;
  }
  .mailOptions {
    width: 100%;
    display: flex;
    margin: 5px auto;
  }
  .inputBox50 {
    width: calc(50% - 32px);
    padding: 0px;
    margin: 0px 16px;
  }
  .togglePasswordContainer {
    width: calc(50% - 32px);
    padding: 0px;
    margin-left: 16px;
    position: relative;
  }
  .togglePassword {
    font-size: 2.5rem;
    color: ${palette.lightgray};
    position: absolute;
    left: calc(92.5% - 3.7rem);
    bottom: 10px;
    cursor: pointer;
  }
  .saveCompany {
    width: 20%;
    padding: 7px 20px;
    background-color: ${(props) => (props.adminColor ? props.adminColor : '#0f3f44')};
    font-size: 1.6rem !important;
    border-radius: 5px;
    color: ${palette.white};
    height: auto;
  },
`;
export default null;
